import React from "react";
import {
  Show,
  BooleanField,
  BooleanInput,
  ShowButton,
  SimpleShowLayout,
  ChipField,
  DateField,
  DateInput,
  List,
  Edit,
  Create,
  Datagrid,
  TextField,
  EditButton,
  SearchInput,
  SingleFieldList,
  SelectArrayInput,
  SimpleForm,
  TextInput,
  Filter,
  required,
  ReferenceArrayField,
  ReferenceArrayInput,
} from "react-admin";

const CustomerTitle = ({ record }) => {
  return (
    <span>
      Customer: {record ? `${record.name ? record.name : record.id}` : ""}
    </span>
  );
};

// Search Function
const CustomerFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
);

export const CustomerList = (props) => (
  <List
    {...props}
    filters={<CustomerFilter />}
    sort={{ field: "name", order: "DESC" }}
  >
    <Datagrid>
      <EditButton />
      <ShowButton />
      <TextField source="name" />
      <TextField source="company" />
      <TextField source="email" />
      <TextField source="phone" />
      <DateField source="date" />
      <BooleanField source="newsletter" />
    </Datagrid>
  </List>
);

export const CustomerEdit = (props) => (
  <Edit title={<CustomerTitle />} {...props}>
    <SimpleForm>
      <TextInput disabled source="id" />
      <TextInput source="name" inputProps={{ maxLength: 50 }} />
      <TextInput source="company" inputProps={{ maxLength: 50 }} />
      <TextInput source="email" inputProps={{ maxLength: 50 }} />
      <TextInput source="phone" inputProps={{ maxLength: 50 }} />
      <DateInput disabled source="date" />
      <BooleanInput source="newsletter" />
      <TextInput source="message" inputProps={{ maxLength: 500 }} />
      <ReferenceArrayInput label="Quotes" reference="products" source="quotes">
        <SelectArrayInput optionText="id" />
      </ReferenceArrayInput>
    </SimpleForm>
  </Edit>
);

export const CustomerCreate = (props) => (
  <Create title="Add Customer" {...props}>
    <SimpleForm>
      <TextInput
        source="name"
        validate={[required()]}
        inputProps={{ maxLength: 50 }}
      />
      <TextInput
        source="company"
        validate={[required()]}
        inputProps={{ maxLength: 50 }}
      />
      <TextInput
        source="email"
        validate={[required()]}
        inputProps={{ maxLength: 50 }}
      />
      <TextInput source="phone" inputProps={{ maxLength: 50 }} />
      <BooleanInput source="newsletter" />
      <TextInput source="message" inputProps={{ maxLength: 500 }} />

      <ReferenceArrayInput label="Quotes" reference="products" source="quotes">
        <SelectArrayInput optionText="id" />
      </ReferenceArrayInput>
    </SimpleForm>
  </Create>
);

export const CustomerShow = (props) => (
  <Show title={<CustomerTitle />} {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="company" />
      <TextField source="email" />
      <TextField source="phone" />
      <DateField source="date" />
      <BooleanField source="newsletter" />
      <TextField source="message" />
      <ReferenceArrayField
        label="Quotes"
        reference="products"
        source="quotes"
        link="show"
      >
        <SingleFieldList>
          <ChipField source="id" />
        </SingleFieldList>
      </ReferenceArrayField>
    </SimpleShowLayout>
  </Show>
);
